<template>
<div class="show-box">
    <div class="active1right" >
        <span class="feeIn-box">支付宝缴费入口</span>
        <img :src="PicAliPayIn" />
    </div>
</div>
</template>

<script>

export default {
    data() {
        return {
            PicAliPayIn: ''
        };
    },
    mounted() {
        this.PicAliPayIn = require('@/assets/image/aliPayIn.png')
    }
};
</script>

<style lang="less" scoped>
.active1right {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin-left: 13px;
    height: 100%;
    position: relative;
}

.active1right .input-yzmd>input {
    width: 228px;
    height: 42px;
    border-radius: 3px;
    border: 1px solid rgba(221, 221, 221, 1);
}

.active1right img {
    width: 350px;
    height: 260px;
    // position: absolute;
    top: 10px;
    left: 7px;
}

.feeIn-box {
    text-align: center;
    width: 350px;
    border-bottom: solid 2px #bb0005;
    font-size: 20px;
    line-height: 50px;
    font-weight: 600;
    color: rgba(221, 33, 38, 1);
}
.show-box {
    width: 100%;
}
</style>
